import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MyErrorStateMatcher } from '../../../../../../common/field-validation/my-error-state-matcher';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';
import { ImageUtils } from '../../../../../../common/utils/image-utils';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DataSourceFactory } from '../../../../../views/maintain/data-source/data-source-factory';
import { DataTypeComponent } from '../../../data-type-component';

@Component({
  selector: 'app-diamond-panel-form-field',
  templateUrl: './diamond-panel-form-field.component.html',
  styleUrls: ['./diamond-panel-form-field.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false,
})
export class DiamondPanelFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: any;

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  @Input() fields: FieldConfigDTO[];

  @Input() canAdd: boolean;

  @Output() valueChanged = new EventEmitter<any[]>();

  public formGroupSubset: UntypedFormGroup;

  public editFields: FieldConfigDTO[];

  public viewFields: FieldConfigDTO[];

  public loading = true;

  public imageSrc: string;

  constructor(
    private environmentService: EnvironmentService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private dataSourceFactory: DataSourceFactory,
    private route: ActivatedRoute,
    private domSanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.createFormGroupsIfNeededV2(this.data);
    this.formGroup.setControl(this.fieldConfig.name, this.formGroupSubset);
    this.editFields = this.fieldConfig.innerFields.filter((f) => !f.editHide);
    this.viewFields = this.fieldConfig.innerFields.filter((f) => !f.viewHide);
    this.loading = false;
    if (typeof this.data.diamondIcon === 'string' && this.data.diamondIcon.indexOf('./assets/') >= 0) {
      this.imageSrc = ImageUtils.relocateImage(this.data.diamondIcon);
    }
  }

  private createFormGroupsIfNeededV2(data: any) {
    const formGroupBuilder = {};
    this.fieldConfig.innerFields.forEach((f) => {
      const formControl = this.getFormControlForField(f, data);
      formGroupBuilder[f.name] = formControl;
    });
    this.formGroupSubset = new UntypedFormGroup(formGroupBuilder);
  }

  private getFormControlForField(f: FieldConfigDTO, data: any) {
    const disabled = f.editReadOnly;
    const value = data[f.name];

    const validators = MyErrorStateMatcher.convertToAngularValidators([f]);
    const formControl = new UntypedFormControl(
      {
        value,
        disabled,
      },
      validators
    );
    return formControl;
  }

  getFields() {
    return this.editMode
      ? this.editFields
      : this.viewFields.filter((f) => {
          const value = this.formGroupSubset.getRawValue()[f.name];
          if (!f.ignoreIfNotPresent) {
            return true;
          }
          return value && Object.keys(value).length > 0;
        });
  }
}
